import { render } from "./BuyMemberPage.vue?vue&type=template&id=cb29cf32&scoped=true"
import script from "./BuyMemberPage.vue?vue&type=script&lang=js"
export * from "./BuyMemberPage.vue?vue&type=script&lang=js"

import "./BuyMemberPage.vue?vue&type=style&index=0&id=cb29cf32&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb29cf32"]])

export default __exports__